import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if this is a ResizeObserver error
    if (
      error &&
      (
        (error.message && error.message.includes('ResizeObserver loop completed with undelivered notifications')) ||
        (error.stack && error.stack.includes('ResizeObserver loop completed with undelivered notifications')) ||
        (error.toString().includes('ResizeObserver'))
      )
    ) {
      // Don't update state for ResizeObserver errors, just ignore them
      return null;
    }
    
    // Update state for other errors
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Check if this is a ResizeObserver error
    if (
      error &&
      (
        (error.message && error.message.includes('ResizeObserver loop completed with undelivered notifications')) ||
        (error.stack && error.stack.includes('ResizeObserver loop completed with undelivered notifications')) ||
        (error.toString().includes('ResizeObserver'))
      )
    ) {
      // Silently ignore ResizeObserver errors
      return;
    }
    
    // Log other errors if needed
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    } else {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI for non-ResizeObserver errors
      return this.props.fallback || (
        <div style={{
          padding: '16px',
          backgroundColor: '#1e293b',
          border: '1px solid #374151',
          borderRadius: '2px',
          textAlign: 'center',
          color: '#6b7280',
          fontSize: '12px'
        }}>
          Content temporarily unavailable
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 